<script>
  import { createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import QRCode from "qrcode";

  import store, { account } from "../etleneumAccountStore";
  import Button from "./Button.svelte";

  let modal;

  const dispatch = createEventDispatcher();
  const close = () => dispatch("close");
  const logOut = () => {
    close();
    account.reset();
  };

  const makeQR = async (data) => {
    try {
      return await QRCode.toDataURL(data, { margin: 0 });
    } catch (err) {
      console.error(err);
    }
  };
</script>

<div class="modal-background" on:click={close} />

<div
  class="modal"
  role="dialog"
  aria-modal="true"
  bind:this={modal}
  in:fly={{ y: 200, duration: 300 }}
  out:fly={{ y: -200, duration: 300 }}
>
  <header>
    {#if $store.id}
      Logged in with id: {$store.id}
    {:else}
      <p>
        Login to Etleneum using an
        <a
          href="https://github.com/fiatjaf/awesome-lnurl#wallets"
          target="_blank">lnurl-auth</a
        >-powered wallet:
      </p>
    {/if}
  </header>
  {#if !$store.id && $store.lnurl.auth}
    {#await makeQR($store.lnurl.auth)}
      <p>Wait...</p>
    {:then qr}
      <figure>
        <a href={`lightning:${$store.lnurl.auth}`}>
          <img src={qr} alt={$store.lnurl.auth} />
        </a>
        <figcaption>{$store.lnurl.auth}</figcaption>
      </figure>
    {:catch error}
      <p>Oh no! Something went wrong!</p>
    {/await}
  {:else}
    {#if parseInt($store.balance / 1000) >= 10}
      {#await makeQR($store.lnurl.withdraw)}
        <p>Wait...</p>
      {:then qrw}
        <figure>
          <a href={`lightning:${$store.lnurl.withdraw}`}>
            <img src={qrw} alt={$store.lnurl.withdraw} />
          </a>
          <figcaption>{$store.lnurl.withdraw}</figcaption>
        </figure>
      {:catch error}
        <p>Oh no! Something went wrong!</p>
      {/await}
    {:else}
      <p>Minimum withdrawable amount is 10 sats!</p>
    {/if}
    <p>Balance: {parseInt($store.balance / 1000)} sats</p>
    <Button title="Log Out" clickAction={logOut} />
    <Button title="Fechar" style="--color: var(--pinker)" clickAction={close} />
    <!-- <button on:click={logOut}>Log Out</button> -->
  {/if}
  <footer>
    Powered by <a href="https://etleneum.com" target="_blank">Etleneum</a>!
  </footer>
</div>

<style>
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 998;
  }

  .modal {
    position: absolute;
    left: 50%;
    top: 40%;
    width: calc(100vw - 4em);
    max-width: 32em;
    max-height: calc(100vh - 4em);
    overflow-x: hidden;
    transform: translate(-50%, -50%);
    padding: 2em;
    border-radius: 0.2em;
    background: white;
    z-index: 999;
  }

  .modal,
  figcaption {
    margin-top: 2em;
    text-align: center;
    font-size: 75%;
    word-break: break-all;
  }
</style>
